const agentCompositionCompare = (a, b) => a.localeCompare(b)

export default function agentCompositionToApi(composition) {
  return composition
    .map(id => id.toLowerCase())
    .sort(agentCompositionCompare)
    .join(',')
}
